export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

export function formatTimestamp(timestamp) {
  if (timestamp == null) return '';

  let date;
  if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === 'string') {
    const parsed = Date.parse(timestamp);
    if (isNaN(parsed)) return '';
    date = new Date(parsed);
  } else if (typeof timestamp === 'number') {
    if (isNaN(timestamp)) return '';
    date = new Date(timestamp);
  } else {
    return '';
  }

  if (isNaN(date.getTime())) return '';
  return date.toLocaleString();
}

export function truncateText(text, maxLength = 50) {
  if (text == null) return '';
  if (typeof text !== 'string') text = String(text);
  if (maxLength < 0) maxLength = 0;
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}